<template>
  <div
      class="separator__container"
      :class="paddingStyle">
    <p
        class="separator__title"
        :class="textCenterStyle">
      {{ title }}
    </p>
  </div>
</template>

<script>
export default {
  name: "SectionSeparator",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    padded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    paddingStyle() {
      if (this.padded) {
        return "separator__padded";
      }

      return "";
    },
    textCenterStyle() {
      if (this.padded) {
        return "separator__title-padded";
      }
      return "separator__title-normal";
    },
  },
};
</script>

<style scoped>
.separator__title {
  margin-left: 16px;

  font-family: "Equip2" !important;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: rgba(66, 66, 66, 0.75);
}

.separator__title-normal {
  margin-top: 19px;
}

.separator__title-padded {
  margin-top: 24px;

  margin-left: 0px;
  text-align: center;
}

.separator__container {
  border-top: #dee5ec solid 1px;
  margin-top: 15px;
}

.separator__padded {
  margin-right: 10px;
  margin-left: 10px;
}
</style>
